import React from 'react';
import Vouchers  from '../../components/MyVouchers';

const MyVouchers = props => {
    return (<Vouchers ></Vouchers>)
}

export default MyVouchers